import Policyholder from '../Policyholder'
import PropTypes from 'prop-types'

/**
 * Render policyholders
 */
function Policyholders({ policyholders }) {
  // Find primary based on flag or default to first in array
  const primarySearchIndex = policyholders.findIndex((user) => user.is_primary)
  const primaryIndex = primarySearchIndex >= 0 ? primarySearchIndex : 0

  return (
    <div className="w-full">
      <h3 className="mb-2 text-lg font-semibold">Policyholders</h3>
      <div className="flex space-x-12">
        {/* Loop and display the first 2 policyholders */}
        {policyholders.slice(0, 2).map((person, index) => (
          <Policyholder
            key={person.name.full}
            person={person}
            isPrimary={primaryIndex === index}
          />
        ))}

        {/* Output count if we have more than 2 */}
        {policyholders.length > 2 && (
          <p className="font-semibold">
            and {policyholders.length - 2} others...
          </p>
        )}
      </div>
    </div>
  )
}

// Define prop types
Policyholders.propTypes = {
  policyholders: PropTypes.array,
}

export default Policyholders
